module.exports = __webpack_public_path__ + "img/logo.ad5eb552.png";